
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {getDevice} from '@/api/device';
import {getDeviceConfigByDeviceId} from "@/api/deviceConfig";
import {getLastDeviceData, modifyPointData, doRequest} from "@/api/deviceData";
import InfiniteLoading from 'vue-infinite-loading';
import {isEmpty} from "@/utils/utils";
import store from '@/store'
import logoImg from '@/assets/logo2.png'
import 'font-awesome/css/font-awesome.css'

export default {
data() {
return {
deviceId: '',
deviceDetail: {},
deviceConfig: {},
lastData: [],
lastDataMap: {},
relayList: [],
logo: logoImg,
dataPoints: {
h5: {
displays: [],
controls: [],
modifiers: [],
}
},
inputShow: false,
currItem: {},
show: false,
flag: true,
hasPermission: false
}
},
name: "device-monitor",
components: {
XHeader,
Grid,
GridItem,
CellBox,
XButton,
Group,
Flexbox,
FlexboxItem,
Toast,
Icon,
InlineXSwitch,
Card,
InfiniteLoading,
Confirm
},
directives: {
TransferDom
},
filters: {
numFormat(value) {
if (typeof value === 'number' && !isNaN(value)) {
if (parseInt(value) != value) {
value = value.toFixed(1);
}
}
value = value + ""
if (value.length > 10) {
value = value.substr(0, 8) + "..."
}
return value;
},
},
methods: {
minute(second) {
return Math.ceil(second / 60);
},
getDeviceInfo() {
getDevice(this.deviceId).then(response => {
this.deviceDetail = response.data;
if (this.deviceDetail.slaves) {
this.slaves = JSON.parse(this.deviceDetail.slaves)
}
});
},
getDeviceConfig() {
getDeviceConfigByDeviceId(this.deviceId).then(response => {
this.deviceConfig = JSON.parse(response.data.dataJson);
this.assembleData();
});
},
getLastData() {
getLastDeviceData(this.deviceId).then(response => {
this.lastData = response.data;
this.lastData.forEach(item => {
this.lastDataMap[item.pointId] = item;
})
this.assembleData();
});
},
assembleData() {
if (this.deviceConfig && this.deviceConfig.h5) {
let configs = Object.keys(this.dataPoints.h5);
configs.forEach(v => {
let configItem = this.deviceConfig.h5[v];
if (!isEmpty(configItem)) {
this.dataPoints.h5[v] = []
configItem.forEach(vv => {
if (!isEmpty(vv)) {
let curItem = this.lastDataMap[vv.pId]
if (curItem) {
this.dataPoints.h5[v].push(curItem);
}
}
})
}
})
}
},
handleSendCmd() {
doRequest(this.deviceId).then(() => {
this.$vux.toast.show({
text: '指令已下发，勿频繁点击',
time: 3000
})
setTimeout(()=>{
this.refreshData();
}, 5000)
}).catch(error => {
this.$vux.toast.show({
type: 'warn',
text: error
})
});
},
blurPromot(item) {
this.currItem = item;
this.inputShow = true;
},
changeSwitch(item) {
this.currItem = item;
if(this.flag) {
this.show = true;
} else {
this.flag = true;
}
},
onCancel () {
this.flag = false;
this.currItem.value = this.currItem.value == 0 ? 1 : 0;
},
onConfirm (msg) {
if (msg) {
this.currItem['value'] = msg;
this.editDataPoints(this.currItem);
} else {
this.$vux.toast.show({
type: 'warn',
text: '设置值不能为空'
})
}
},
onConfirmSwitch() {
this.editDataPoints(this.currItem);
},
async editDataPoints(item) {
modifyPointData(item).then(response => {
this.$vux.toast.show({
text: '修改成功',
time: 3000
})
}).catch(error => {
this.$vux.toast.show({
type: 'warn',
text: error
})
});
},
refreshData() {
this.getLastData();
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
},
onClickBack() {
this.$router ? this.$router.back() : window.history.back()
},
debounce(func, threshold, execAsap) {
let timeout;
return function debounced() {
let obj = this, args = arguments;

function delayed() {
if (!execAsap)
func.apply(obj, args);
timeout = null;
};
if (timeout) {
clearTimeout(timeout);
} else if (execAsap) {
func.apply(obj, args);
}
timeout = setTimeout(delayed, threshold || 100);
};
}
},
created() {
this.deviceId = this.$route.params.id;
if (!this.deviceId) {
return;
}
this.logo = store.getters.logo ? store.getters.logo : this.logo;
console.log(store.getters.permissions, '1111');
if (store.getters.permissions && (store.getters.permissions.includes('iot:deviceData:edit') || store.getters.permissions.includes('*:*:*'))) {
this.hasPermission = true;
}
this.getDeviceInfo();
this.getDeviceConfig();
},
mounted() {
this.refreshData();
},
computed: {}
}



// WEBPACK FOOTER //
// ./src/components/device-monitor.vue